jQuery(document).ready(function ($) {

    var slidCart = $('.mini-cart');

    $('.minicart').click(function (event) {
        event.preventDefault();
        $(slidCart).addClass('cart-drawer');
        $("body, html").addClass("cart-drawer--open");
        firstWord();
        // slidCart.classList.add('animate', 'active');
    });

    $('.mini-cart .close').click(function (e) {
        e.preventDefault();
        $('body').find('.mini-cart').removeClass('cart-drawer');
        $("body, html").removeClass('cart-drawer--open');
    });


    // Sample products form minicart
    if ($('.samples').length) {
        var currentItems = [];
        $('.mini-items li').each(function () {
            var itemId = $(this).find('input.added-item-id').val();
            if (itemId != undefined) {
                currentItems.push(parseInt(itemId));
            }
        });

        var cartSamples = [];
        var cartSamplesRefresh = [];
        $('.samples .sample-product').each(function (index) {
            var sample = $(this).find('a.minicart-sample-add');
            var samplesLength = $('.samples .sample-product').length - 1;
            
            if ($.inArray(parseInt(sample.attr('data-id')), currentItems) != -1) {
                cartSamplesRefresh.push(1)
            } else {
                cartSamplesRefresh.push(0)
            }

            if (samplesLength == index && jQuery.inArray(1, cartSamplesRefresh) !== -1){
                $('.minicart-sample-add').addClass('disabled');
                cartSamplesRefresh = [];
            } else if (samplesLength == index && jQuery.inArray(1, cartSamplesRefresh) == -1){
                $('.minicart-sample-add').removeClass('disabled');
                cartSamplesRefresh = [];
            }

            $(sample).click(function () {
                var itm = $(this);
                var clicked = $(this).attr('data-id');
                // CartJS.addItem(clicked);
                CartJS.addItem(clicked, 1, {}, {

                    // Define a success callback to display a success message.
                    "success": function (data, textStatus, jqXHR) {
                        console.log(data)
                        console.log(itm)
                        $('.minicart-sample-add').addClass('disabled');
                    },

                    // Define an error callback to display an error message.
                    "error": function (jqXHR, textStatus, errorThrown) {
                        console.log('There was a problem adding to the cart!');
                    }

                });
            })

            $(document).on('cart.requestComplete', function (event, cart) {

               
                setTimeout(() => {
                    var cartItems = [];
                    $(cart.items).each(function () {
                        var immId = $(this)[0].variant_id;
                        if (immId != undefined) {
                            cartItems.push(immId);
                        }
                        firstWord();
                    });

                    if ($.inArray(parseInt(sample.attr('data-id')), cartItems) != -1) {
                        cartSamples.push(1)
                    } else {
                        cartSamples.push(0)
                    }

                    if (samplesLength == index && jQuery.inArray(1, cartSamples) !== -1){
                        $('.minicart-sample-add').addClass('disabled');
                        cartSamples = [];
                    } else if (samplesLength == index && jQuery.inArray(1, cartSamples) == -1){
                        $('.minicart-sample-add').removeClass('disabled');
                        cartSamples = [];
                    }
                    
                    if (cart.total_price == 0) {
                        CartJS.clear(options = {});
                    }
                    
                }, 200);

                // $('#counter').html(cart.item_count);

                delete_sample_product(cart);
            });
        });


        function firstWord(){
            $(".wrap-first-word").html(function () {
                var text = $(this).text().trim().split(" ");
                var first = text.shift();
                return (text.length > 0 ? "<span class='first-word'>" + first + "</span> " : first) + text.join(" ");
            });
        }

    }
    
});
function delete_sample_product(cart) {
    let items = cart.items,
    valida_item = false,
    item_in_cart,
    item_route = false;
    items.forEach(item => {
        if (item.variant_id == 43952880910613 || item.variant_id == 39849773400145 ){
            valida_item = true;
            item_in_cart = item.variant_id;
        }
        if(item.handle == 'routeins'){
            item_route = true;
           console.log('route in cart') 
        }
        
    });

    if((cart.items_subtotal_price <= 1 && valida_item == true) || ( cart.item_count <= 2 &&  item_route == true &&  valida_item == true ) ){
        CartJS.updateItemById(item_in_cart, 0);
    }
}